import { BaseDto } from "@/shared/dtos/base-dto";

export class estados_cita extends BaseDto {
  public codigo: string = "";
  public nombre: string = "";
  public bloquea_agenda: boolean = false;
  public es_final: boolean = false;
  public orden_visual: number = 0;

  constructor(data?: any) {
    super();
    if (!data) return;
    this.copy(data);
  }
}
